import script from "./WorkItemDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkItemDetails.vue?vue&type=script&setup=true&lang=js"

import "./WorkItemDetails.vue?vue&type=style&index=0&id=e06c7c9a&lang=css"

const __exports__ = script;

export default __exports__